import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Bank } from "../../core/model/bank";
import { City } from "../../core/model/city";
import { BankService } from "../../core/service/bank.service";
import { CityService } from "../../core/service/city.service";

@Component({
  selector: "app-add-bank",
  templateUrl: "./add-bank.component.html",
  styleUrls: ["./add-bank.component.scss"],
})
export class AddBankComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  bank: Bank = new Bank();
  cities: City[];

  constructor(
    private _router: Router,
    private _cityService: CityService,
    private _bankService: BankService,
    private fb: FormBuilder
  ) {
    this.bank.active = true;
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [true, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.nullValidator])],
      address: [null, Validators.compose([Validators.required])],
      ville: [null, Validators.compose([Validators.nullValidator])],
      city: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getCities();
  }

  getCities() {
    this._cityService.getAllCities().subscribe(
      (data) => {
        this.cities = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    if (!this.form.valid || this.pressButton) {
      return;
    }
    this.pressButton = true;
    this._bankService
      .postBank(this.bank)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/bank");
  }
}
